module.exports = __webpack_public_path__ + "img/warn.8e7deb6d.svg";